module.exports = __webpack_public_path__ + "img/administration.01fb57f7.svg";